import { InformativeStatus } from '@/components/shared/informative-status/informative-status.types';

interface getPaaNoContractingAuthorityInformativeStatusProps {
  subtitle: string;
  goToPaaCurrentPlans: () => void;
}

export const getPaaNoContractingAuthorityInformativeStatus = ({
  goToPaaCurrentPlans,
}: getPaaNoContractingAuthorityInformativeStatusProps): InformativeStatus => {
  return {
    title: 'Vous ne pouvez pas actuellement créer un nouveau PAA',
    subtitle: `Toutes les AC dont vous êtes membre ont des PAA en cours en cours pour l'année ${new Date().getFullYear()}.`,
    iconProps: { icon: 'pi pi-info-circle', class: 'text-primary text-[10rem]' },
    actionButton: {
      label: 'Retour à la liste',
      onClick: goToPaaCurrentPlans,
    },
  };
};
